<template>
	<div>
		<svg
			:width="iconSize"
			:height="iconSize"
			viewBox="0 0 25 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M8.98437 12.5C8.98437 12.7157 8.80949 12.8906 8.59375 12.8906C8.37801 12.8906 8.20312 12.7157 8.20312 12.5C8.20312 12.2843 8.37801 12.1094 8.59375 12.1094C8.80949 12.1094 8.98437 12.2843 8.98437 12.5ZM8.98437 12.5H8.59375M12.8906 12.5C12.8906 12.7157 12.7157 12.8906 12.5 12.8906C12.2843 12.8906 12.1094 12.7157 12.1094 12.5C12.1094 12.2843 12.2843 12.1094 12.5 12.1094C12.7157 12.1094 12.8906 12.2843 12.8906 12.5ZM12.8906 12.5H12.5M16.7969 12.5C16.7969 12.7157 16.622 12.8906 16.4062 12.8906C16.1905 12.8906 16.0156 12.7157 16.0156 12.5C16.0156 12.2843 16.1905 12.1094 16.4062 12.1094C16.622 12.1094 16.7969 12.2843 16.7969 12.5ZM16.7969 12.5H16.4062M21.875 12.5C21.875 17.2462 17.6777 21.0937 12.5 21.0937C11.5756 21.0937 10.6824 20.9711 9.83872 20.7426C8.82308 21.4561 7.58542 21.875 6.25 21.875C6.04248 21.875 5.83725 21.8649 5.63507 21.8451C5.46875 21.8289 5.30395 21.8061 5.14145 21.7771C5.64512 21.1826 6.00288 20.4611 6.1603 19.6675C6.25473 19.1914 6.02157 18.7291 5.67379 18.3905C4.09344 16.8522 3.125 14.7798 3.125 12.5C3.125 7.7538 7.32233 3.90625 12.5 3.90625C17.6777 3.90625 21.875 7.7538 21.875 12.5Z"
				:stroke="color"
				stroke-width="1.5625"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgBubble',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<style scoped></style>
